export function getValidationToastMessage(
  errorMessages: Array<string | null | undefined>,
  fallback = 'Please fix validation errors',
) {
  const uniqueErrors = Array.from(
    new Set(errorMessages.map((message) => message?.trim()).filter(Boolean)),
  ) as string[];

  if (uniqueErrors.length === 0) {
    return fallback;
  }

  if (uniqueErrors.length === 1) {
    return uniqueErrors[0];
  }

  const visibleErrors = uniqueErrors.slice(0, 3);
  const remainingCount = uniqueErrors.length - visibleErrors.length;
  const suffix = remainingCount > 0 ? `; +${remainingCount} more` : '';

  return `${visibleErrors.join('; ')}${suffix}`;
}
